var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69873 8.68018L14.0004 14.6418L24.232 8.71514",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 25.212V14.6304",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5852 2.8935L5.35522 6.35853C3.94355 7.1402 2.78857 9.10018 2.78857 10.7102V17.3019C2.78857 18.9119 3.94355 20.8718 5.35522 21.6535L11.5852 25.1186C12.9152 25.8536 15.0969 25.8536 16.4269 25.1186L22.6569 21.6535C24.0686 20.8718 25.2236 18.9119 25.2236 17.3019V10.7102C25.2236 9.10018 24.0686 7.1402 22.6569 6.35853L16.4269 2.8935C15.0852 2.14683 12.9152 2.14683 11.5852 2.8935Z",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8334 15.4466V11.1766L8.76172 4.7832",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcel);
export default __webpack_public_path__ + "static/media/parcel.d45ed07eb64a2c3ef8ceed469ab3109a.svg";
export { ForwardRef as ReactComponent };